import { Injectable } from '@angular/core';
import { Http, Headers, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { AjaxService } from '../../../core/services/ajax.service';

@Injectable()
export class ReportService {
    baseUrl: string = 'Reports.svc';    
constructor(private http: Http, private _ajaxService: AjaxService) {
}
generateBillOfLoading(dataToBePost){
    return this._ajaxService.POST(this.baseUrl + "/billofloading", dataToBePost);
}
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/services/reports.service.ts